import {
  BRUNSWIJCK_LOCATION_CODE,
  PARC_IMSTENRADE_LOCATION_CODE,
  PEPPELRODE_LOCATION_CODE,
  VITALIS_BESTUURSCENTRUM_LOCATION_CODE,
  VITALIS_DE_PALADIJN_LOCATION_CODE,
  VITALIS_DILLENBURGSTRAAT_LOCATION_CODE,
  VITALIS_FLEXPOOL_LOCATION_CODE,
  VITALIS_RESIDENTIE_DE_HOEVE_LOCATION_CODE,
  VITALIS_RESIDENTIE_GENDERSTATE_LOCATION_CODE,
  VITALIS_RESIDENTIE_GENNEP_LOCATION_CODE,
  VITALIS_RESIDENTIE_PETRUSPARK_LOCATION_CODE,
  VITALIS_RESIDENTIE_WILGENHOF_LOCATION_CODE,
  VITALIS_VONDERHOF_LOCATION_CODE,
  VITALIS_WISSEHAEGE_LOCATION_CODE,
  WONEN_AAN_DE_FAKKELLAAN_LOCATION_CODE,
  WOONINCPLUSVITALIS_BERCKELHOF_LOCATION_CODE,
  WOONINCPLUSVITALIS_DE_DREEF_LOCATION_CODE,
  WOONINCPLUSVITALIS_DE_HAGEN_LOCATION_CODE,
  WOONINCPLUSVITALIS_DE_HORST_LOCATION_CODE,
  WOONINCPLUSVITALIS_KORTONJO_LOCATION_CODE,
  WOONINCPLUSVITALIS_KRONEHOEF_LOCATION_CODE,
  WOONINCPLUSVITALIS_LINT_LOCATION_CODE,
  WOONINCPLUSVITALIS_MAXIMILIAAN_LOCATION_CODE,
  WOONINCPLUSVITALIS_PARC_GENDER_ENGELSBERGEN_LOCATION_CODE,
  WOONINCPLUSVITALIS_THERESIA_LOCATION_CODE,
  WOONINCPLUSVITALIS_WILGENHOF_LOCATION_CODE,
} from '@constants';

const locations = [
  {
    id: 1,
    title: 'Eindhoven Noord',
    children: [
      'Vitalis Brunswijck',
      'Vitalis Peppelrode',
      'Vitalis Wonen aan de Fakkellaan',
      'WoonincPlusVitalis de Horst',
      'WoonincPlusVitalis Kronehoef',
      'WoonincPlusVitalis De Dreef',
      'Vitalis Residentie Petruspark',
      'Vitalis Residentie De Hoeve',
    ],
    codes: [
      BRUNSWIJCK_LOCATION_CODE,
      PEPPELRODE_LOCATION_CODE,
      WONEN_AAN_DE_FAKKELLAAN_LOCATION_CODE,
      WOONINCPLUSVITALIS_DE_HORST_LOCATION_CODE,
      WOONINCPLUSVITALIS_KRONEHOEF_LOCATION_CODE,
      WOONINCPLUSVITALIS_DE_DREEF_LOCATION_CODE,
      VITALIS_RESIDENTIE_PETRUSPARK_LOCATION_CODE,
      VITALIS_RESIDENTIE_DE_HOEVE_LOCATION_CODE,
    ],
  },
  {
    id: 2,
    title: 'Eindhoven Midden',
    children: [
      'Vitalis Vonderhof',
      'WoonincPlusVitalis Engelsbergen (Parc Gender)',
      'WoonincPlusVitalis Maximiliaan (Parc Gender)',
      'WoonincPlusVitalis De Hagen (Parc Gender)',
      'WoonincPlusVitalis Berckelhof',
      'WoonincPlusVitalis Theresia',
      'Vitalis Residentie Genderstate (Parc Gender)',
    ],
    codes: [
      VITALIS_VONDERHOF_LOCATION_CODE,
      WOONINCPLUSVITALIS_PARC_GENDER_ENGELSBERGEN_LOCATION_CODE,
      WOONINCPLUSVITALIS_MAXIMILIAAN_LOCATION_CODE,
      WOONINCPLUSVITALIS_DE_HAGEN_LOCATION_CODE,
      WOONINCPLUSVITALIS_BERCKELHOF_LOCATION_CODE,
      WOONINCPLUSVITALIS_THERESIA_LOCATION_CODE,
      VITALIS_RESIDENTIE_GENDERSTATE_LOCATION_CODE,
    ],
  },
  {
    id: 3,
    title: 'Eindhoven Zuid',
    children: [
      'Vitalis Wissehaege',
      'WoonincPlusVitalis ‘Lint',
      'WoonincPlusVitalis Kortonjo',
      'WoonincPlusVitalis Wilgenhof',
      'Vitalis Residentie Wilgenhof',
      'Vitalis Residentie Gennep',
    ],
    codes: [
      VITALIS_WISSEHAEGE_LOCATION_CODE,
      WOONINCPLUSVITALIS_LINT_LOCATION_CODE,
      WOONINCPLUSVITALIS_KORTONJO_LOCATION_CODE,
      WOONINCPLUSVITALIS_WILGENHOF_LOCATION_CODE,
      VITALIS_RESIDENTIE_WILGENHOF_LOCATION_CODE,
      VITALIS_RESIDENTIE_GENNEP_LOCATION_CODE,
    ],
  },
  {
    id: 4,
    title: 'Geldrop',
    children: ['Vitalis de Paladijn'],
    codes: [VITALIS_DE_PALADIJN_LOCATION_CODE],
  },
  {
    id: 5,
    title: 'Heerlen',
    children: ['Vitalis Parc Imstenrade'],
    codes: [PARC_IMSTENRADE_LOCATION_CODE],
  },
  {
    id: 6,
    title: 'Vitalis Flexpool',
    children: ['Flexmedewerkers en ZZP’ers'],
    codes: [VITALIS_FLEXPOOL_LOCATION_CODE],
  },
  {
    id: 7,
    title: 'Vitalis Bestuurscentrum',
    children: ['Directie, Staf & Ondersteunende diensten'],
    codes: [VITALIS_BESTUURSCENTRUM_LOCATION_CODE],
  },
  {
    id: 8,
    title: 'Vitalis Dillenburgstraat',
    children: ['HR Services'],
    codes: [VITALIS_DILLENBURGSTRAAT_LOCATION_CODE],
  },
];

export default locations;
